"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _classnames = _interopRequireDefault(require("classnames"));

var _creatableSelectModule = _interopRequireDefault(require("./creatableSelect.module.css"));

var _arrowRightIcon = _interopRequireDefault(require("../icons/arrowRightIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reactSelectCustomStyles = {
  control: function control(provided, state) {
    return _objectSpread({}, provided, {
      border: '1px solid #d8d8d8',
      borderRadius: '0px',
      boxShadow: '0 1px 3px #d8d8d8 inset',
      '&:hover': {
        border: '1px solid #d8d8d8'
      },
      minHeight: 36
    });
  },
  container: function container(base) {
    return _objectSpread({}, base, {
      minHeight: 34
    });
  },
  placeholder: function placeholder(base) {
    return _objectSpread({}, base, {
      fontWeight: 'normal',
      color: '#000',
      fontFamily: "Arial, sans-serif",
      fontSize: "15px"
    });
  },
  loadingIndicator: function loadingIndicator(base) {
    return _objectSpread({}, base, {
      marginRight: '18px'
    });
  },
  dropdownIndicator: function dropdownIndicator(base) {
    return _objectSpread({}, base);
  },
  clearIndicator: function clearIndicator(base) {
    return _objectSpread({}, base, {
      paddingTop: 0,
      paddingBottom: 0,
      color: "#000",
      marginRight: '28px',
      position: "absolute",
      top: 8,
      right: 0
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base, {
      display: 'flex',
      alignItems: "center"
    });
  },
  indicatorSeparator: function indicatorSeparator(base) {
    return {
      display: 'none'
    };
  },
  input: function input(base) {
    return _objectSpread({}, base, {
      margin: 0,
      padding: 0,
      fontFamily: 'arial, sans-serif',
      color: 'black'
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread({}, provided, {
      zIndex: 3
    });
  },
  option: function option(base) {
    return _objectSpread({}, base, {
      fontFamily: 'arial, sans-serif',
      color: 'black',
      fontSize: '1em; color: #000'
    });
  }
};

var DropdownIndicator = function DropdownIndicator(props) {
  return _react.default.createElement(_reactSelect.components.DropdownIndicator, props, _react.default.createElement("button", {
    className: (0, _classnames.default)(_creatableSelectModule.default["btn"], _creatableSelectModule.default["form-control"], _creatableSelectModule.default["buttonPicker"]),
    tabIndex: -1
  }, _react.default.createElement(_arrowRightIcon.default, {
    className: _creatableSelectModule.default["icon-arrow"]
  })));
};

var CreatableSelectInput = function CreatableSelectInput(props) {
  var options = props.options,
      onChange = props.onChange,
      value = props.value,
      isLoading = props.isLoading,
      instanceId = props.instanceId,
      isDisabled = props.isDisabled,
      onCreateOption = props.onCreateOption,
      onBlur = props.onBlur,
      autoComplete = props.autoComplete;
  return _react.default.createElement(_reactSelect.Creatable, {
    inputProps: {
      autoComplete: autoComplete ? autoComplete : ""
    },
    onCreateOption: onCreateOption,
    styles: reactSelectCustomStyles,
    value: value,
    instanceId: instanceId,
    isLoading: isLoading,
    isDisabled: isDisabled,
    components: {
      DropdownIndicator: DropdownIndicator
    },
    onChange: onChange,
    options: options,
    onBlur: onBlur
  });
};

var _default = CreatableSelectInput;
exports.default = _default;